import { LogConfig } from './logger.models';

export const DEFAULT_LOG_CONFIG: LogConfig = {
  enableConsole: true,
  enableBackendTransport: false,
  enableLocalStorage: true,
  batchSize: 10,
  batchInterval: 30000,
  maxLogs: 1000,
  sensitiveKeys: [
    'password',
    'token',
    'jwt',
    'secret',
    'apiKey',
    'authorization',
    'cookie',
    'sessionId',
  ],
};

export const LOCALSTORAGE_KEY = 'frontend_critical_errors';
